module.exports = __webpack_public_path__ + "img/home-solution-zhihui.acaa2acd.png";